import React, { useState } from 'react'
import Dashboardnavbarcopy from '../../layout/Dashboardnavbarcopy';
import { AssetsManagement } from '../UserDetails/Assettable';
import { InterComTable } from '../workforcemanagement/Organizationtables';


const Settingsit = () => {

    const [toggleState, setToggleState] = useState(1);


    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Assest';
            case 2:
                return 'InterCom';
            case 3:
            default:
                return '';
        }
    };


    return (
        <>
            <div>
                <Dashboardnavbarcopy name={getSelectedTitle()} url="Settings" />
                <div className="wfm-margin    bloc-tabs-with-white-bg">
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
                        onClick={() => setToggleState(1)}
                    >
                        Asset
                    </button>
                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(2)}
                    >
                        InterCom
                    </button>
                </div>

                <div>
                    {toggleState === 1 ? <AssetsManagement /> : null}
                    {toggleState === 2 ? <InterComTable /> : null}
                </div>
            </div>

        </>
    )
}

export default Settingsit
